import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_IMPOUNDS_ACTION_TYPE } from '../actions';

const initialState = {};

const impoundsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_IMPOUNDS_ACTION_TYPE.GET_IMPOUNDS:
      case LOAN_IMPOUNDS_ACTION_TYPE.EDIT_IMPOUNDS:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default impoundsReducer;
